import { render, staticRenderFns } from "./PersonnelUserInfo.vue?vue&type=template&id=58cd9b54&"
import script from "./PersonnelUserInfo.vue?vue&type=script&lang=js&"
export * from "./PersonnelUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports